/* Service order builder, driven by markup (used by sections/hc-design-build.liquid):
   package radios [data-svc-pkg] + add-on rows [data-svc-addon] → live total and delivery estimate → cart → checkout.
   Add-on row attributes:
   - data-name: label in the summary
   - data-variant / data-price / data-days: a fixed add-on (days are added per unit)
   - data-by-pkg='{"pkgKey":[variantId, priceCents, days]}': price depends on the package
   - data-mode="fast": days replace the delivery estimate instead of adding to it
   - data-only="pkgA pkgB": only offered for these packages
   - data-unit=" per page": suffix for the price label [data-svc-price] in the row
   - data-svc-pages marks the extra-page quantity row; data-svc-per-page on an on/off row charges it once for the
     package page plus once per extra page (days are counted once)
   Quantity rows hold [data-svc-qty] with [data-svc-step] buttons; on/off rows hold a [data-svc-toggle] checkbox. */
(function () {
  var form = document.querySelector('[data-svc-order]');
  var dataEl = document.querySelector('[data-svc-data]');
  if (!form || !dataEl) return;
  var data = JSON.parse(dataEl.textContent);
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var linesEl = form.querySelector('[data-svc-lines]');
  var totalEl = form.querySelector('[data-svc-total]');
  var etaEl = form.querySelector('[data-svc-eta]');
  var submit = form.querySelector('[data-svc-submit]');
  var errEl = form.querySelector('[data-svc-err]');
  var bar = document.querySelector('[data-svc-bar]');

  function money(cents) {
    var amount = (cents / 100).toLocaleString('en-GB', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
    return data.money.replace(/<[^>]*>/g, '').replace(/\{\{\s*\w+\s*\}\}/, amount);
  }
  function pkgKey() {
    var r = form.querySelector('[data-svc-pkg]:checked');
    return r ? r.getAttribute('data-svc-pkg') : Object.keys(data.packages)[0];
  }
  /* [variantId, priceCents, days] for a row under the current package. */
  function offer(row, key) {
    var by = row.getAttribute('data-by-pkg');
    if (by) return JSON.parse(by)[key] || null;
    return [+row.getAttribute('data-variant'), +row.getAttribute('data-price'), +(row.getAttribute('data-days') || 0)];
  }
  function qtyOf(row) {
    var q = row.querySelector('[data-svc-qty]');
    if (q) return Math.max(0, Math.min(50, parseInt(q.value, 10) || 0));
    if (!row.querySelector('[data-svc-toggle]').checked) return 0;
    if (!row.hasAttribute('data-svc-per-page')) return 1;
    var pages = form.querySelector('[data-svc-pages]');
    return 1 + (pages && !pages.hidden ? qtyOf(pages) : 0);
  }

  function selection() {
    var key = pkgKey();
    var pkg = data.packages[key];
    var items = [{ id: pkg.variant, quantity: 1, name: pkg.name, price: pkg.price }];
    var days = pkg.days, fastDays = 0;
    form.querySelectorAll('[data-svc-addon]').forEach(function (row) {
      if (row.hidden) return;
      var qty = qtyOf(row), o = offer(row, key);
      if (!qty || !o) return;
      items.push({ id: o[0], quantity: qty, name: row.getAttribute('data-name'), price: o[1], perPage: row.hasAttribute('data-svc-per-page') });
      if (row.getAttribute('data-mode') === 'fast') fastDays = o[2];
      else days += row.hasAttribute('data-svc-per-page') ? o[2] : o[2] * qty;
    });
    /* Extra-fast sets the package time; development time still comes on top. */
    if (fastDays) days = days - pkg.days + fastDays;
    return { key: key, items: items, days: days };
  }

  function render() {
    var key = pkgKey();
    form.querySelectorAll('[data-svc-addon]').forEach(function (row) {
      var only = row.getAttribute('data-only');
      var show = !only || only.split(' ').indexOf(key) !== -1;
      row.hidden = !show;
      if (!show) { var t = row.querySelector('[data-svc-toggle]'); if (t) t.checked = false; }
      var label = row.querySelector('[data-svc-price]'), o = offer(row, key);
      if (label && o) {
        label.textContent = row.getAttribute('data-mode') === 'fast'
          ? money(o[1]) + ' · delivered in ' + o[2] + ' days instead of ' + data.packages[key].days
          : money(o[1]) + (row.getAttribute('data-unit') || '') + (o[2] ? ' · +' + o[2] + (o[2] === 1 ? ' day' : ' days') : '');
      }
    });
    var sel = selection(), total = 0;
    linesEl.innerHTML = '';
    sel.items.forEach(function (i) {
      total += i.price * i.quantity;
      var li = document.createElement('li'), n = document.createElement('span'), p = document.createElement('b');
      n.textContent = i.name + (i.quantity > 1 ? ' × ' + i.quantity + (i.perPage ? ' pages' : '') : '');
      p.textContent = money(i.price * i.quantity);
      li.append(n, p);
      linesEl.appendChild(li);
    });
    if (totalEl.textContent !== money(total)) {
      totalEl.textContent = money(total);
      totalEl.classList.remove('is-bump'); void totalEl.offsetWidth; totalEl.classList.add('is-bump');
    }
    etaEl.textContent = sel.days + ' days';
    if (bar) {
      bar.querySelector('[data-svc-bar-name]').textContent = data.packages[key].name;
      bar.querySelector('[data-svc-bar-total]').textContent = money(total);
    }
  }

  form.addEventListener('change', render);
  form.addEventListener('input', function (e) { if (e.target.matches('[data-svc-qty]')) render(); });
  form.addEventListener('click', function (e) {
    var b = e.target.closest('[data-svc-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('[data-svc-qty]');
    input.value = Math.max(0, Math.min(50, (parseInt(input.value, 10) || 0) + +b.getAttribute('data-svc-step')));
    render();
  });

  /* Replace earlier lines for this service, add the order (package last so the cart lists it first) and go to checkout. */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var sel = selection();
    submit.disabled = true;
    submit.classList.add('is-busy');
    errEl.hidden = true;
    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (i) { if (data.productIds.indexOf(i.product_id) !== -1) updates[i.key] = 0; });
        if (Object.keys(updates).length) return fetch(root + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: updates }) });
      })
      .then(function () {
        return fetch(root + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: sel.items.map(function (i) { return { id: i.id, quantity: i.quantity }; }).reverse() }) });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = root + 'checkout';
      })
      .catch(function () {
        submit.disabled = false;
        submit.classList.remove('is-busy');
        errEl.hidden = false;
      });
  });

  /* Phones: keep the chosen package card centred in the swipe row. */
  var pkgs = form.querySelector('[data-svc-pkgs]');
  function centre(card, smooth) {
    if (!pkgs || pkgs.scrollWidth <= pkgs.clientWidth) return;
    pkgs.scrollTo({ left: card.offsetLeft - (pkgs.clientWidth - card.offsetWidth) / 2, behavior: smooth ? 'smooth' : 'auto' });
  }
  form.addEventListener('change', function (e) { if (e.target.matches('[data-svc-pkg]')) centre(e.target.closest('.hsb-pkg'), true); });
  var pop = pkgs && pkgs.querySelector('.hsb-pkg--pop');
  if (pop) centre(pop, false);

  /* Sticky order bar: shown once the hero is passed, hidden while the order summary is on screen. */
  if (bar && 'IntersectionObserver' in window) {
    var pastHero = false, sumVisible = false;
    var sync = function () {
      var show = pastHero && !sumVisible;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', String(!show));
      bar.querySelector('[data-svc-bar-go]').tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(function (en) { pastHero = !en[0].isIntersecting; sync(); }).observe(document.querySelector('.hsb-hero'));
    new IntersectionObserver(function (en) { sumVisible = en[0].isIntersecting; sync(); }).observe(form.querySelector('[data-svc-sum]'));
    bar.querySelector('[data-svc-bar-go]').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else submit.click();
    });
  }

  render();
})();
